import 'css-chunksrc/client/scenes/listDuplication/styles.scss';export default {
  "listDuplication": "_listDuplication_1e0ig_1",
  "message": "_message_1e0ig_13",
  "footer": "_footer_1e0ig_19",
  "button": "_button_1e0ig_26"
};